// extracted by mini-css-extract-plugin
export default {"select":"select___ye_W7"};